import { AddressType } from "@/common/enum";

export class XeroAddressModel {
  public addressType!: AddressType;
  public addressLine1!: string;
  public addressLine2!: string;
  public addressLine3!: string;
  public addressLine4!: string;
  public city!: string;
  public region!: string;
  public postalCode!: string;
  public country!: string;
  public attentionTo!: string;

  constructor() {
    this.addressType = AddressType.POBOX;
    this.addressLine1 = "";
    this.addressLine2 = "";
    this.addressLine3 = "";
    this.addressLine4 = "";
    this.city = "";
    this.region = "";
    this.postalCode = "";
    this.country = "";
    this.attentionTo = "";
  }
}
